import { Flex, Text } from '@chakra-ui/react';

import FigmaTriangleDown from 'components/Icons/FigmaTriangleDown';

export interface FormatProperties {
  selectedCellColor: string;
  handleCellColorChange: (event: any) => void;
}

const RowCellColor = ({ handleCellColorChange, selectedCellColor }: FormatProperties) => {
  return (
    <Flex alignItems={'center'} justifyContent={'space-between'}>
      <Text fontFamily='Roboto Regular' fontWeight='500' fontSize='13px' color='#121826'>
        Cell colour
      </Text>
      <Flex
        alignItems='center'
        gap='8px'
        border='1px solid #E8E9EB'
        borderRadius='8px'
        px='11px'
        py='4px'
        h='29px'
      >
        <input
          type='color'
          value={selectedCellColor || '#FFFFFF'}
          onChange={(event) => handleCellColorChange(event.target.value)}
          style={{
            width: '20px',
            height: '20px',
            border: '1px solid #D9D9D9',
            borderRadius: '4px',
            padding: 0,
            background: 'none',
          }}
        />
        <FigmaTriangleDown width={10} height={6} color='#708090' />
      </Flex>
    </Flex>
  );
};
export default RowCellColor;
